<template>
  <vs-popup id="popupReferenceTable"  :active.sync="popupActiveSync" title="위험성평가 기준표">
    <div style="display: grid; gap:1.25rem; padding: 1.25rem; grid-template-columns: 1fr 1fr; grid-template-rows: 1fr 1fr; overflow:auto;" >
      <div>
        <div class="table-header type1">
          <div class="bg grid-구분">구분</div>
          <div class="bg grid-강도">중대성(강도)</div>
          <div class="bg grid-강도3">3</div>
          <div class="bg grid-강도2">2</div>
          <div class="bg grid-강도1">1</div>
          <div class="bg grid-빈도">가능성(빈도)</div>
          <div class="bg grid-빈도3">3</div>
          <div class="bg grid-빈도2">2</div>
          <div class="bg grid-빈도1">1</div>
          <div class="bg-danger grid-33">9(높음)</div>
          <div class="bg-danger grid-32">6(높음)</div>
          <div class="bg-warning grid-31">3(보통)</div>
          <div class="bg-danger grid-23">6(높음)</div>
          <div class="bg-warning grid-22">3(보통)</div>
          <div class="bg-success grid-21">2(낮음)</div>
          <div class="bg-warning grid-13">3(보통)</div>
          <div class="bg-success grid-12">2(낮음)</div>
          <div class="bg-success grid-11">1(낮음)</div>
        </div>
      </div>

      <div>
        <div class="table-header type2">
          <div class="bg">위험성수준</div>
          <div class="bg">관리기준</div>
          <div class="bg">내용</div>
          <div class="bg-danger">6~9(높음)</div>
          <div class="">즉시개선</div>
          <div class="text-left">작업을 지속하려면 즉시 개선이 필요한 상태</div>
          <div class="bg-warning">3~4(보통)</div>
          <div class="">개선</div>
          <div class="text-left">안전보건대책을 수립하여 개선이 필요한 상태</div>
          <div class="bg-warning">1~2(낮음)</div>
          <div class="">현장유지</div>
          <div class="text-left">근로자에게 유해·위험 정보제공 및 교육 등이 필요한 상태</div>
        </div>
      </div>
      <div>
        <div class="table-header type3">
          <div class="bg">가능성(빈도)</div>
          <div class="bg">내용</div>
          <div class="bg">3</div>
          <div class="text-left">일반적 또는 반복적으로 발생</div>
          <div class="bg">2</div>
          <div class="text-left">발생 가능성 있음</div>
          <div class="bg">1</div>
          <div class="text-left">발생 가능성 거의 없음</div>
        </div>
      </div>
      <div>
        <div class="table-header type3">
          <div class="bg">중대성(강도)</div>
          <div class="bg">내용</div>
          <div class="bg">3</div>
          <div class="text-left">일반적 또는 반복적으로 발생</div>
          <div class="bg">2</div>
          <div class="text-left">발생 가능성 있음</div>
          <div class="bg">1</div>
          <div class="text-left">발생 가능성 거의 없음</div>
        </div>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import DateSelector from '../../components/DateSelector'
import FileUploader from '../../components/FileUploader'

export default {
  name: 'PopupReferenceTable',
  props: {
    value: Boolean,
    imageName: String,
  },
  components: {
  },
  data () {
    return {
      imageUrl1: require('@/assets/images/빈도_팝업.png'),
      imageUrl2: require('@/assets/images/강도_팝업.png'),
      imageUrl3: require('@/assets/images/위험도_팝업.png')
    }
  },
  computed: {
    popupActiveSync: {
      get () {
        return this.value
      },
      set () {
        this.$emit('input', false)
      }
    }
  },
  created () {
  },
  methods: {
  }
}

</script>

<style lang="scss" scoped>
.table-header {

  border-left: 1px solid #DEDEDE;
  border-top: 1px solid #DEDEDE;

  div {
    display: flex;
    justify-content: center;
    align-items: center;

    border-right: 1px solid #DEDEDE;
    border-bottom: 1px solid #DEDEDE;
    padding-left: 8px;
  }

  .bg { background-color: #F9F9F9; }
  .bg-danger { background-color: #F08182; }
  .bg-warning { background-color: #FFB976; }
  .bg-success { background-color: #48DA89; }
  .text-left { justify-content: left; text-align: left;}

  &.type1 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 40px 40px 40px 40px 40px;
    grid-template-areas:
    "a a b b b"
    "a a b3 b2 b1"
    "c c3 c3b3 c3b2 c3b1"
    "c c2 c2b3 c2b2 c2b1"
    "c c1 c1b3 c1b2 c1b1";

    .grid-구분 { grid-area: a }
    .grid-강도 { grid-area: b }
    .grid-강도1 { grid-area: b1 }
    .grid-강도2 { grid-area: b2 }
    .grid-강도3 { grid-area: b3 }
    .grid-빈도 { grid-area: c }
    .grid-빈도1 { grid-area: c1 }
    .grid-빈도2 { grid-area: c2 }
    .grid-빈도3 { grid-area: c3 }
    .grid-11 { grid-area: c1b1 }
    .grid-12 { grid-area: c1b2 }
    .grid-13 { grid-area: c1b3 }
    .grid-21 { grid-area: c2b1 }
    .grid-22 { grid-area: c2b2 }
    .grid-23 { grid-area: c2b3 }
    .grid-31 { grid-area: c3b1 }
    .grid-32 { grid-area: c3b2 }
    .grid-33 { grid-area: c3b3 }
  }

  &.type2 {
    display: grid;
    grid-template-columns: 1fr 1fr 3fr;
    grid-template-rows: 80px 40px 40px 40px;
  }

  &.type3 {
    display: grid;
    grid-template-columns: 1fr 4fr;
    grid-template-rows: 40px 40px 40px 40px;
  }
}
</style>

<style>

#popupReferenceTable > .vs-popup {
  width: 1200px !important;
}

#popupReferenceTable > .vs-popup > .vs-popup--content {
  width: 100%;
  padding: 0;
  margin: 0;
}

#popupReferenceTable > .vs-popup > .vs-popup--content > .vs-row {
  padding: 24px;

}
</style>
